// app.serverRequest - Cross domain http requests (ajax)
//
// This script provides a fallback for browsers that do not support CORS (IE)
// using an iframe hosted on mobi2go.com and using postMessage for
// communication and JSONP for larger GET requests (to avoid parsing large
// JSON strings as postMessage only supports strings in IE)
//
// note: Although IE has XDomainRequest, it's a piece of crap because it doesn't
// support http to https requests.
// TODO: tidy up
import jQuery from 'jquery';
import _ from 'lodash';

const FORCE_IFRAME_XDR = false; // fo'testin'

Mobi2Go.app.serverRequest = settings => {
    settings = prepareSettings(settings);
    jQuery.ajax(settings);
};

// jQuery.ajax if CORS is available
if (!jQuery.support.cors || FORCE_IFRAME_XDR) {
    // IFRAME FALLBACK //
    Mobi2Go.app.serverRequest = iframeServerRequest;
    const iframe = createIframe(); // Create iframe
    let iframe_loaded = false;
    // store for request callbacks
    const request_callbacks = {
        complete: {},
        success: {},
        error: {},
    };

    // Listen for responses from the iframe
    if (window.addEventListener)
        // normal browsers
        window.addEventListener('message', iframeResponseHandler, false);
    else if (window.attachEvent)
        // IE
        window.attachEvent('onmessage', iframeResponseHandler);

    // Iframe load event
    iframe.onload = function() {
        iframe_loaded = true;
    };
    iframe.onreadystatechange = function() {
        if (
            iframe.readyState === 'complete' ||
            iframe.readyState === 'loaded'
        ) {
            iframe_loaded = true;
        }
    };
}

function iframeServerRequest(settings) {
    // Generate a unique id for request so we can identify the response
    const request_id = +new Date() + ~(Math.random() * 100000);

    settings = prepareSettings(settings);

    // JSONP Request
    if (settings.jsonp && settings.type === 'GET') {
        // Globally accessible callback store for JSONP requests
        if (!Mobi2Go.app.jsonp_callback) Mobi2Go.app.jsonp_callback = {};

        Mobi2Go.app.jsonp_callback[request_id] = function(response) {
            settings.success(response);
            delete Mobi2Go.app.jsonp_callback[request_id];
        };

        settings.url += `${'&callback=' +
            'Mobi2Go.app.jsonp_callback['}${request_id}]`;

        if (settings.data) {
            settings.url += `&${jQuery.param(settings.data)}`;
        }

        Mobi2Go.helpers.loadScripts([settings.url]);
        return;
    }

    // If iframe has not loaded - wait 20ms and try request again
    if (!iframe_loaded) {
        const retry = function() {
            iframeServerRequest(settings);
        };
        setTimeout(retry, 20);
        return;
    }

    // Object to be sent to the iframe
    const data = {
        request_id,
        data: settings.data,
        contentType: settings.contentType,
        type: settings.type,
        url: settings.url,
    };

    // Store callbacks to be fired when a response is received back from
    // the iframe
    request_callbacks.complete[request_id] = _.isFunction(settings.complete)
        ? settings.complete
        : function() {};

    request_callbacks.success[request_id] = _.isFunction(settings.success)
        ? settings.success
        : function() {};

    request_callbacks.error[request_id] = _.isFunction(settings.error)
        ? settings.error
        : function() {};

    // Send request to iframe (which will do the ajax request)
    iframe.contentWindow.postMessage(
        JSON.stringify(data),
        Mobi2Go.app.base_url
    );
}

function iframeResponseHandler(message) {
    if (!message) return;
    const response = JSON.parse(message.data);
    const { request_id } = response;
    const { status } = response;
    let payload;

    if (!request_id) return;
    // turn payload into an array so it can be passed as an arguments array
    payload = _.toArray(response.payload);

    // Execute for request id callback if present
    request_callbacks[status][request_id].apply(null, payload);
}

function createIframe() {
    // Create and insert iframe
    // TODO: implement something to ensure the iframe loads before trying to
    // fire off ajax requests
    const iframe = document.createElement('iframe');
    iframe.src = `${Mobi2Go.app.base_url}/store/application/v3/dist/xdr-iframe.php?ho=${Mobi2Go.headoffice.id}`;
    iframe.id = 'm2g-xdr-iframe';
    iframe.style.display = 'none';
    document.getElementsByTagName('head')[0].appendChild(iframe);

    return iframe;
}

// Prepares settings provided from a app.serverRequest call to be used in
// jQuery.ajax
function prepareSettings(settings) {
    if (_.isArray(settings.endpoint)) {
        settings.endpoint = settings.endpoint.join('/');
    }
    // Construct URL
    settings.api_version = settings.api_version || 1.3;

    const base_url = settings.from_cdn
        ? Mobi2Go.app.cdn_url
        : Mobi2Go.app.base_url;
    settings.url = `${base_url}/api/${settings.api_version}/headoffice/${Mobi2Go.headoffice.domain_name}/${settings.endpoint}`;

    if (window.M2G_XDEBUG) {
        settings.url += '&XDEBUG_PROFILE';
    }

    // Includes session cookies and X-Session header by default
    const include_credentials = settings.with_credentials !== false;

    // Add query string if specified
    if (settings.query_string) {
        settings.url += `&${settings.query_string}`;
    }
    settings.type = settings.type || 'GET';
    settings.dataType = 'json';
    settings.cache = true; // Prevents jQuery global settings from appending timestamp to query string
    settings.xhrFields = { withCredentials: include_credentials };
    settings.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
    settings.processData = true;

    if (include_credentials && Mobi2Go.app.session_id) {
        settings.headers = {
            'X-Session': Mobi2Go.app.session_id,
        };
    }

    // /api/1/ Expects a JSON payload
    if (settings.api_version === 1 && settings.type !== 'GET') {
        settings.contentType = 'application/json';
        settings.processData = false;
        settings.data = JSON.stringify(settings.data);
    }

    // Error handling
    const error_callback = _.isFunction(settings.error)
        ? settings.error
        : function() {
              return false;
          };
    settings.error = function(xhr, message) {
        // call request-specific error-handling function
        // the request callback can opt to not fire the generic
        // 'serverRequestError' event by returning
        const error_was_handled = error_callback.apply(null, arguments);

        // Trigger generic 'serverRequestError' event
        Mobi2Go.trigger(
            'app',
            'serverRequestError',
            xhr,
            message,
            settings.endpoint,
            error_was_handled
        );
    };

    settings.timeout = settings.timeout || 100000;
    return settings;
}
